import { useEffect } from "react";

import useSystemStore from "@store/useSystemStore";
import { useTimeoutRef } from "@hooks/useTimeoutRef";

const OFFLINE_DELAY = 1000; // delay to show ConnectionIssueScreen
const ONLINE_DELAY = 1000; // delay to hide ConnectionIssueScreen

export function useNetworkStatus() {
  const { setIsAppOffline } = useSystemStore();
  const { schedule } = useTimeoutRef();

  useEffect(() => {
    const updateOnlineStatus = () => {
      schedule(
        () => {
          setIsAppOffline(!navigator.onLine);
        },
        navigator.onLine ? ONLINE_DELAY : OFFLINE_DELAY
      );
    };

    updateOnlineStatus();

    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);

    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, [setIsAppOffline, schedule]);
}
